import React from 'react';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import { MapPin, Navigation } from 'lucide-react';
import { extractLocation, extractCoordinates } from '../../../utils/propertyUtils';

/**
 * Componente para exibir localização e coordenadas da propriedade
 * @param {Object} props - Propriedades do componente
 * @param {Object} props.propertyData - Dados da propriedade
 * @returns {JSX.Element} Localização e coordenadas da propriedade
 */
const PropertyLocation = ({ propertyData }) => {
  const location = extractLocation(propertyData) || 'Local não identificado';
  const coordinates = propertyData?.properties ? extractCoordinates(propertyData) : null;

  // Log para debug
  const DEBUG = import.meta.env.VITE_DEBUG === 'true';
  if (DEBUG)
    // eslint-disable-next-line no-console
    console.log('[PropertyLocation] Dados extraídos:', {
      location,
      coordinates,
      temPropriedades: propertyData?.properties ? true : false,
      temCar: propertyData?.properties?.car ? true : false,
      temSigef: propertyData?.properties?.sigef ? true : false,
    });

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.5, mb: 2 }}>
      {/* Primeira linha: Localização município/UF */}
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <MapPin size={18} className="mr-2" color="#666" />
        <Typography variant="body2" color="textSecondary">
          {location}
        </Typography>
      </Box>

      {/* Segunda linha: Coordenadas */}
      {coordinates && (
        <Box sx={{ display: 'flex', alignItems: 'center', pl: 1 }}>
          <Navigation size={16} className="mr-2" color="#666" />
          <Tooltip title="Latitude, Longitude">
            <Typography variant="body2" color="textSecondary" sx={{ fontFamily: 'monospace' }}>
              {coordinates.lat}, {coordinates.lng}
            </Typography>
          </Tooltip>
        </Box>
      )}
    </Box>
  );
};

export default PropertyLocation;
